module.exports = __webpack_public_path__ + "img/aftersalesLogo3.92dba100.png";